module.exports = __webpack_public_path__ + "static/4-90edaf98b052690036d07c7e822b1a4b.jpeg";